import cn from "../utils/cn";
import "./orders.css";
import { useNavigate } from "react-router-dom";
import { IconPrinter, IconExternalLink } from "@tabler/icons-react";
import print from "print-js";
import { getGroupName } from "./orders";

function OrderList(props) {
  const orders = props.orders;
  const completeOrders = (completedOrders) => {
    orders.completeOrders(completedOrders);
  };
  return (
    <div className="px-4 sm:px-6 lg:px-8 w-full">
      <div className="mt-4 flow-root">
        <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
            <div className="relative">
              <table className="min-w-full table-fixed divide-y divide-gray-300">
                <thead className="sticky top-0">
                  <Headers
                    orders={orders.state}
                    checkbox={props.checkbox}
                    checked={props.checked}
                    toggleAll={props.toggleAll}
                    selectedOrders={props.selectedOrders}
                    completeOrders={completeOrders}
                  />
                </thead>
                <tbody className="divide-y divide-gray-200 bg-white overflow-scroll h-100">
                  {Array.from(orders.state).map((order, idx) => (
                    <TableRow
                      key={`table-row-${idx}`}
                      order={order}
                      selectedOrders={props.selectedOrders}
                      setSelectedOrders={props.setSelectedOrders}
                      completeOrders={completeOrders}
                    />
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
function TableRow({
  order,
  selectedOrders,
  setSelectedOrders,
  completeOrders,
}) {
  const navigate = useNavigate();
  return (
    <tr
      className={
        selectedOrders.includes(order.order_id) ? "bg-gray-50" : undefined
      }
    >
      <td className="relative px-7 sm:w-12 sm:px-6">
        {selectedOrders.includes(order.order_id) && (
          <div className="absolute inset-y-0 left-0 w-0.5 bg-indigo-600" />
        )}
        <div className="group absolute left-4 top-1/2 -mt-2 grid size-4 grid-cols-1">
          <input
            type="checkbox"
            className="col-start-1 row-start-1 appearance-none rounded border border-gray-300 bg-white checked:border-indigo-600 checked:bg-indigo-600 props.indeterminate:border-indigo-600 props.indeterminate:bg-indigo-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 disabled:border-gray-300 disabled:bg-gray-100 disabled:checked:bg-gray-100 forced-colors:appearance-auto"
            value={order.email}
            checked={selectedOrders.includes(order.order_id)}
            onChange={(e) =>
              setSelectedOrders(
                e.target.checked
                  ? [...selectedOrders, order.order_id]
                  : selectedOrders.filter((p) => p !== order.order_id)
              )
            }
          />
          <svg
            className="pointer-events-none col-start-1 row-start-1 size-3.5 self-center justify-self-center stroke-white group-has-[:disabled]:stroke-gray-950/25"
            viewBox="0 0 14 14"
            fill="none"
          >
            <path
              className="opacity-0 group-has-[:checked]:opacity-100"
              d="M3 8L6 11L11 3.5"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              className="opacity-0 group-has-[:indeterminate]:opacity-100"
              d="M3 7H11"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
      </td>
      <td
        className={cn(
          "whitespace-nowrap py-4 pr-3 xl:text-md text-sm font-medium",
          selectedOrders.includes(order) ? "text-indigo-600" : "text-gray-900"
        )}
      >
        <span className="flex items-center">
          <span>
            {order.first_name} {order.last_name}
          </span>
          <button
            className="text-blue-600 pb-1 ps-2"
            onClick={() => navigate(`/order/${order.order_id}`)}
          >
            <IconExternalLink />
          </button>
        </span>
        {order.feedback_content && (
          <div className="text-wrap text-gray-600">
            Feedback: {order.feedback_content}
          </div>
        )}
      </td>
      <td className="whitespace-nowrap px-3 py-4 text-sm xl:text-md text-gray-500">
        <div>{order.email}</div>
        <div>
          {order.phone_number.replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2 - $3")}
        </div>
        <div className="xl:hidden">{order.address_1}</div>
        <div className="xl:hidden">{order.address_2}</div>
        <div className="xl:hidden">
          {order.city} {order.state} {order.zip_code}
        </div>
      </td>
      <td className="whitespace-nowrap px-3 py-4 text-md text-gray-500 max-xl:hidden">
        <div>{order.address_1}</div>
        <div>{order.address_2}</div>
        <div>
          {order.city} {order.state} {order.zip_code}
        </div>
      </td>
      <td className="whitespace-nowrap px-3 py-4 text-sm xl:text-md text-gray-500">
        <span className="xl:hidden">PC:</span>
        {order.discount_code}
        <div className="xl:hidden">C:{order.send_cups ? "True" : "False"}</div>
      </td>
      <td className="whitespace-nowrap px-3 py-4 text-md text-gray-500 max-xl:hidden">
        {order.send_cups ? "True" : "False"}
      </td>
      <td className="whitespace-nowrap px-3 py-4 text-sm xl:text-md text-gray-500">
        <div className="">
          {order.items
            .sort((a, b) => a.line_item_id - b.line_item_id)
            .map((item, idx) => (
              <div key={`table-row-${idx}`} className="items-center flex">
                <input type="checkbox" className="me-1" />
                <span className="">
                  [{getGroupName(item.item_group_id)}] {item.item_name} (
                  {item.item_count})
                </span>
                {item.item_group_id === 4 && (
                  <span className="ps-2">{item.item_note}</span>
                )}
              </div>
            ))}
        </div>
      </td>

      <td className="whitespace-nowrap py-4 text-sm font-medium sm:pr-3 relative ps-8">
        <button
          onClick={() => completeOrders([order.order_id])}
          className="inline-flex items-center gap-x-1.5 rounded-md bg-indigo-600 px-2.5 py-1.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
        >
          Complete<span className="sr-only">, {order.name}</span>
        </button>
      </td>
      <td className="whitespace-nowrap py-4 text-sm font-medium sm:pr-3 relative ">
        <div className="" />
        <button
          onClick={() => print(`row-${order.order_id}`, "html")}
          title="print"
          className="text-indigo-600 hover:text-indigo-900"
        >
          <IconPrinter />
        </button>
        <div className="hidden">
          <PrintRow order={order} />
        </div>
      </td>
    </tr>
  );
}
function PrintAllRows({ orders }) {
  return (
    <div id="print-all-orders">
      {orders.map((order, idx) => (
        <div key={`print-order-${idx}`}>
          <PrintRow order={order} />
          <div css={"page-break-after: always"} />
        </div>
      ))}
    </div>
  );
}
function PrintRow({ order }) {
  return (
    <div id={`row-${order.order_id}`}>
      <div className="text-5xl font-bold">Big Blue Energy</div>
      <br />
      <div>Ship To</div>
      <div>
        {order.first_name} {order.last_name}
      </div>
      <div>
        {order.address_1} {order.address_2}
      </div>
      <div>
        {order.city} {order.state} {order.zip_code}
      </div>
      <br />
      {order.discount_code.trim() && (
        <div>
          POMO CODE: {order.discount_code}
          <br />
          <br />
        </div>
      )}
      {(order.feedback_name || order.feedback_content) && (
        <div>
          Feedback
          <div>
            {order.feedback_name}: {order.feedback_content}
            <br />
            <br />
          </div>
        </div>
      )}
      <table>
        <thead>
          <tr>
            <th>QTY</th>
            <th>ITEM NAME</th>
            <th>UNIT PRICE</th>
            <th>TOTAL</th>
          </tr>
        </thead>
        <tbody>
          {order.items.map((item, idx) => (
            <tr key={`item-${idx}`}>
              <td>{item.item_count}</td>
              <td>{item.item_name}</td>
              <td>{(item.item_price / 100).toFixed(2)}</td>
              <td>{((item.item_price * item.item_count) / 100).toFixed(2)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

function Headers({
  checkbox,
  checked,
  toggleAll,
  orders,
  selectedOrders,
  completeOrders,
}) {
  return (
    <tr>
      <th scope="col" className="relative px-7 sm:w-12 sm:px-6">
        <div className="group absolute left-4 top-1/2 -mt-2 grid size-4 grid-cols-1">
          <input
            type="checkbox"
            className="col-start-1 row-start-1 appearance-none rounded border border-gray-300 bg-white checked:border-indigo-600 checked:bg-indigo-600 indeterminate:border-indigo-600 indeterminate:bg-indigo-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 disabled:border-gray-300 disabled:bg-gray-100 disabled:checked:bg-gray-100 forced-colors:appearance-auto"
            ref={checkbox}
            checked={checked}
            onChange={toggleAll}
          />
          <svg
            className="pointer-events-none col-start-1 row-start-1 size-3.5 self-center justify-self-center stroke-white group-has-[:disabled]:stroke-gray-950/25"
            viewBox="0 0 14 14"
            fill="none"
          >
            <path
              className="opacity-0 group-has-[:checked]:opacity-100"
              d="M3 8L6 11L11 3.5"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              className="opacity-0 group-has-[:props.indeterminate]:opacity-100"
              d="M3 7H11"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
      </th>
      <th
        scope="col"
        className="xl:min-w-[12rem] py-3.5 pr-3 text-left text-sm font-semibold text-gray-900"
      >
        Name
      </th>
      <th
        scope="col"
        className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
      >
        Contact
      </th>
      <th
        scope="col"
        className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 max-xl:hidden"
      >
        Address
      </th>
      <th
        scope="col"
        className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
      >
        Promotional Code
        <span className="xl:hidden"> / Send Cups</span>
      </th>

      <th
        scope="col"
        className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 max-xl:hidden"
      >
        Send Cups
      </th>
      <th
        scope="col"
        className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
      >
        Line Items
      </th>
      <th
        scope="col"
        className="relative py-3.5 pl-3 pr-4 sm:pr-3 text-nowrap "
      >
        {selectedOrders.length > 0 && (
          <button
            onClick={() => completeOrders(selectedOrders)}
            type="button"
            className="inline-flex items-center gap-x-1.5 rounded-md bg-indigo-600 px-2.5 py-1.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          >
            Complete All
          </button>
        )}
      </th>
      <th
        scope="col"
        className="relative py-3.5 pl-3 pr-4 sm:pr-3 text-nowrap "
      >
        {selectedOrders.length > 0 && (
          <div>
            <button
              onClick={() =>
                print({
                  printable: "print-all-orders",
                  type: "html",
                  targetStyles: ["page-break-after"],
                })
              }
              title="print"
              className="text-indigo-600 hover:text-indigo-900"
            >
              <IconPrinter />
            </button>
            <div className="hidden">
              <PrintAllRows
                orders={orders.filter((x) =>
                  selectedOrders.includes(x.order_id)
                )}
              />
            </div>
          </div>
        )}
      </th>
    </tr>
  );
}
export default OrderList;
